import { render, staticRenderFns } from "./Goback.vue?vue&type=template&id=33a6d91c&scoped=true&"
import script from "./Goback.vue?vue&type=script&lang=js&"
export * from "./Goback.vue?vue&type=script&lang=js&"
import style0 from "./Goback.vue?vue&type=style&index=0&id=33a6d91c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a6d91c",
  null
  
)

export default component.exports